import { useEffect, useState } from "react";
import { ChatsCircle, Copy, Sparkle, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { teleproApi } from "../../lib/teleproApi";

// VAGUE 42 — Coach commercial : réponse prête par objection + adaptation IA au prospect.
let cache = null;

export default function ObjectionCoachPanel({ biz, onQualify, onStatus }) {
  const [items, setItems] = useState(cache || []);
  const [active, setActive] = useState(null);
  const [ai, setAi] = useState({ loading: false, replies: [] });

  useEffect(() => {
    if (cache) return;
    teleproApi.get("/coach/objections").then((r) => { cache = r.data.objections; setItems(cache); }).catch(() => {});
  }, []);

  const pick = (o) => { setActive(o); setAi({ loading: false, replies: [] }); };
  const copy = async (t) => {
    try { await navigator.clipboard.writeText(t); toast.success("Copié"); } catch { /* noop */ }
  };
  const adapt = async () => {
    setAi({ loading: true, replies: [] });
    try {
      const r = await teleproApi.post("/ai/objection", {
        business_id: biz.id, objection: `${active.label} — ${active.response}`,
      });
      const replies = r.data?.replies || [];
      setAi({ loading: false, replies });
      if (!replies.length) toast.error("L'IA n'a pas répondu — utilise la réponse prête");
    } catch {
      setAi({ loading: false, replies: [] });
      toast.error("IA indisponible — utilise la réponse prête");
    }
  };

  return (
    <div className="mb-3 border border-primary/25 bg-primary/5 rounded-sm p-3" data-testid={`objection-coach-panel-${biz.id}`}>
      <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-bold text-primary mb-2">
        <ChatsCircle size={14} weight="duotone"/> Coach : le prospect dit…
      </div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((o) => (
          <button key={o.id} type="button" onClick={() => pick(o)}
            className={`text-[11px] font-semibold border rounded-full px-2.5 py-1 transition-colors ${
              active?.id === o.id ? "bg-primary text-primary-foreground border-primary"
                : o.id === "no_more_contact" ? "bg-card border-red-300 text-red-800 hover:bg-red-50"
                : "bg-card border-border hover:border-primary"}`}
            data-testid={`coach-objection-${o.id}`}>
            {o.label}
          </button>
        ))}
      </div>
      {active && (
        <div className="mt-2.5 bg-card border border-border rounded-sm p-2.5 space-y-2" data-testid="coach-answer">
          <div className="flex items-start gap-2">
            <p className="text-sm leading-snug flex-1" data-testid="coach-answer-text">« {active.response.replace(/\*\*/g, "")} »</p>
            <button type="button" onClick={() => copy(active.response.replace(/\*\*/g, ""))} className="p-1 text-muted-foreground hover:text-primary" aria-label="Copier" data-testid="coach-answer-copy">
              <Copy size={13}/>
            </button>
          </div>
          {active.tip && <p className="text-[11px] text-muted-foreground">Conseil : {active.tip}</p>}
          <div className="flex flex-wrap gap-1.5">
            {active.id === "no_more_contact" ? (
              <button type="button" onClick={() => onQualify({ status: "refused_final", refusal_reason: "no_more_contact" })}
                className="text-[11px] font-bold bg-red-700 text-white rounded-sm px-2.5 py-1.5 inline-flex items-center gap-1" data-testid="coach-record-no-more-contact">
                Enregistrer : ne plus contacter <ArrowRight size={11} weight="bold"/>
              </button>
            ) : (
              <button type="button" onClick={adapt} disabled={ai.loading}
                className="text-[11px] font-bold bg-primary text-primary-foreground rounded-sm px-2.5 py-1.5 inline-flex items-center gap-1 disabled:opacity-60" data-testid="coach-adapt-ai">
                <Sparkle size={11} weight="fill"/> {ai.loading ? "L'IA réfléchit…" : "Adapter avec l'IA à ce prospect"}
              </button>
            )}
            {active.next_status === "callback" && (
              <button type="button" onClick={() => onStatus("callback")}
                className="text-[11px] font-semibold border border-[#C8795A]/50 text-[#C8795A] rounded-sm px-2.5 py-1.5" data-testid="coach-set-callback">
                Programmer un rappel
              </button>
            )}
          </div>
          {ai.replies.map((r, i) => (
            <div key={i} className="flex items-start gap-2 text-sm bg-primary/5 border border-primary/20 rounded-sm px-2 py-1.5" data-testid={`coach-ai-reply-${i}`}>
              <span className="flex-1">« {r} »</span>
              <button type="button" onClick={() => copy(r)} className="p-1 text-muted-foreground hover:text-primary" aria-label="Copier"><Copy size={12}/></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
